export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10560.72afb8da.jpg";